/**
 * Utility to generate and download ICS (iCal) files for system calendars
 */
import { Countdown } from '../types/database';

export function downloadICS(countdown: Countdown) {
  const date = new Date(countdown.event_date);
  
  // Format dates for ICS (YYYYMMDD)
  const startDate = date.toISOString().replace(/-|:|\.\d+/g, '').split('T')[0];
  const endDate = new Date(date.getTime() + 24 * 60 * 60 * 1000)
    .toISOString().replace(/-|:|\.\d+/g, '').split('T')[0];

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Countr//NONSGML Event Calendar//EN',
    'BEGIN:VEVENT',
    `UID:${countdown.id}@countr.app`,
    `DTSTAMP:${new Date().toISOString().replace(/-|:|\.\d+/g, '')}`,
    `DTSTART;VALUE=DATE:${startDate}`,
    `DTEND;VALUE=DATE:${endDate}`,
    `SUMMARY:${countdown.emoji || '📅'} ${countdown.name}`,
    `DESCRIPTION:Countdown reminder created on Countr. Category: ${countdown.category}`,
    'BEGIN:VALARM',
    'TRIGGER:-PT1440M', // 1 day before
    'ACTION:DISPLAY',
    'DESCRIPTION:Reminder',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute('download', `${countdown.name.replace(/\s+/g, '_')}.ics`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function getGoogleCalendarUrl(countdown: Countdown) {
  const date = new Date(countdown.event_date);
  const startDate = date.toISOString().replace(/-|:|\.\d+/g, '').split('T')[0];
  const endDate = new Date(date.getTime() + 24 * 60 * 60 * 1000)
    .toISOString().replace(/-|:|\.\d+/g, '').split('T')[0];
  
  const baseUrl = 'https://www.google.com/calendar/render?action=TEMPLATE';
  const params = new URLSearchParams({
    text: `${countdown.emoji || '📅'} ${countdown.name}`,
    dates: `${startDate}/${endDate}`,
    details: `Countdown tracked with Countr.`,
    sf: 'true',
    output: 'xml'
  });
  
  return `${baseUrl}&${params.toString()}`;
}